export let dexLitePaneHeaderShellPane = "ge3lv";
export let dictationHelpHeaderText = "a3ZV$b";
export default {dexLitePaneHeaderShellPane,dictationHelpHeaderText};